module.exports = __webpack_public_path__ + "static/media/hw_ya_36.287c8106.flv";